import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../MainScreen/MainScreen.css';
import GButton from '../../components/ui/base/GButton';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { ReactComponent as CasinoIcon } from '../../assets/icons/casino.svg';
import { ReactComponent as LotteryIcon } from '../../assets/icons/lottery.svg';
import { ReactComponent as Home } from '../../assets/icons/home.svg';
import { ReactComponent as Slot } from '../../assets/icons/slot.svg';
import { ReactComponent as Table } from '../../assets/icons/table.svg';
import { ReactComponent as Blackjack } from '../../assets/icons/blackjack.svg';
import { ReactComponent as Baccarat } from '../../assets/icons/baccarat.svg';
import { ReactComponent as Roulette } from '../../assets/icons/roulette.svg';
import { ReactComponent as Poker } from '../../assets/icons/poker.svg';
import { ReactComponent as MiniGame } from '../../assets/icons/miniGame.svg';
import { ReactComponent as Live } from '../../assets/icons/live.svg';
import { ReactComponent as Plinko } from '../../assets/icons/plinko.svg';
import { GameWithCategories } from '../MainScreen/GameWithCategories';
import { AllGamesByCategory } from './AllGamesByCategory';
import useMainStore from '../../store/mainState';
import { useMutation, useQuery } from '@apollo/client';
import { EXIT_GAME } from '../../graphql/games';
import LoaderOverlay from '../../components/ui/LoaderOverlay';
import { GET_USER } from '../../graphql/auth';
// import { Sections } from './Sections';
// import { BigWinns } from './BigWinns';
// import { GameWithCategories } from './GameWithCategories';
import { useLocation } from 'react-router-dom';


const categories = [{
  id: 'All',
  label: 'Lobby',
  icon: <Home />,
},
{
  id: 'SLOT',
  label: 'Slots',
  icon: <Slot />,
},
{
  id: 'Blackjack',
  label: 'Blackjack',
  icon: <Blackjack />,
},
{
  id: 'Baccarat',
  label: 'Baccarat',
  icon: <Baccarat />,
},
{
  id: 'Roulette',
  label: 'Roulette',
  icon: <Roulette />,
},
{
  id: 'POKER',
  label: 'Poker',
  icon: <Poker />,
},
// {
//   id: 'LOTTERY',
//   label: 'Lottery',
//   icon: <LotteryIcon />,
// },
{
  id: 'LIVE',
  label: 'Live Casino',
  icon: <Live />,
},
{
  id: 'MINI_GAME',
  label: 'Mini Game',
  icon: <MiniGame />,
},
{
  id: 'PLINKO',
  label: 'Plinko',
  icon: <Plinko />,
},
{
  id: 'OTHER',
  label: 'Other',
  icon: <CasinoIcon />,
},
]

const categoriesGames = categories.slice(1, categories.length - 1);

const Casino = () => {
  const { t } = useTranslation();
  const [search, setSearch] = React.useState('');
  const location = useLocation();
  // const [activeSubItem, setActiveSubItem] = React.useState('All');
  const { setActiveSubItem, activeSubItem, setIsSignUpOpen, setMainContentWidth } = useMainStore();
  const [activeSubItemTitle, setActiveSubItemTitle] = useState('');
  const mainScreen = useRef<HTMLDivElement>(null);
  const { gameState, user, setGameState, setUser } = useMainStore();
  const { loading: userLoading, error: userError, data: userData, refetch: refetchUser } = useQuery(GET_USER, {
    variables: { id: user?.id },
    skip: !user?.id, // Skip the query if no userId
    fetchPolicy: 'cache-and-network' // Always refetch from server
  });
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;

      setMainContentWidth(width);
    });

    if (mainScreen.current) {
      observer.observe(mainScreen.current);
    }

    return () => observer.disconnect();
  }, []);


  return (
    <div className="main-screen" ref={mainScreen}>
      <section className='flex flex-row rounded-[6px] md:rounded-[25px] overflow-hidden relative p-[10px] md:p-[0px]'>
        <img src={require("../../assets/images/bannerBg.png")} alt="" className='absolute inset-0 w-full h-full object-cover' />
        <div className='flex-[2] md:flex-[1] md:py-[10px] py-[5px] pl-[10px] md:pl-[18px] lg:my-[24px] lg:pl-[55px] xl:my-[34px] xl:pl-[75px] flex flex-col z-[1]'>
          <h1 className='text-[14px] md:text-[20px] lg:text-[30px] xl:text-[45px] font-bold text-white italic'>{t('mainScreen.stayUntamed')}</h1>
          <h2 className='text-[8px] md:text-[10px] lg:text-[16px] xl:text-[22px] font-bold text-white/80 italic'>{t('mainScreen.signUpGet')}</h2>
          <h1 className='whitespace-nowrap text-[14px] md:text-[20px] lg:text-[30px] xl:text-[45px] font-bold text-white flex items-center italic'>{t('mainScreen.upTo')} &nbsp; <span className='font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#0086D3] via-[#4DBDFF] to-[#4DBDFF]'> $20,000.00</span></h1>
          <h3 className='text-[8px] md:text-[10px] lg:text-[16px] xl:text-[22px] font-bold text-white/80 italic'>{t('mainScreen.inCasinoOrSports')}</h3>
          {!user && <GButton children={t('common.signUp')} textStyle="font-bold" className="flex-1 rounded-full xl:h-[50px] xl:min-h-[50px] xl:max-h-[50px] h-[30px] max-h-[30px] mt-[10px] md:mt-[25px] min-h-[30px] max-w-[200px]" onClick={() => { setIsSignUpOpen(true) }} />}
        </div>
        <div className='flex-[2] md:flex-[1] flex items-center justify-center z-[1] py-[10px]'>
          <img className='h-[100%] max-h-[200px] xl:max-h-[280px] object-contain' src={require("../../assets/images/casino-banner.png")} alt="" />
        </div>
      </section>
      <section>
        {activeSubItem === 'All' &&
          <div className='w-full bg-white/[0.04] backdrop-blur-sm border border-white/[0.06] rounded-[14px] mt-[20px] px-[16px] py-[12px] flex items-center transition-all duration-300 focus-within:border-[#0086D3]/30 focus-within:bg-white/[0.08] focus-within:shadow-[0_0_20px_rgba(0,134,211,0.1)]'>
            <SearchIcon className="opacity-40" />
            <input type="text" className='w-full bg-transparent outline-none text-[16px] md:text-[18px] text-white pl-[12px] placeholder-white/25 font-medium' placeholder={t('casino.searchGame')} value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        }
        <div className='w-full flex mt-[16px] gap-[6px] overflow-x-auto scrollbar-hide pb-[4px]'>
          {categories.map((category) => (
            <button key={category.id} className={`flex items-center gap-[8px] px-[14px] py-[10px] rounded-[12px] flex-shrink-0 transition-all duration-300 ${activeSubItem === category.id ? 'bg-[#0086D3]/15 border border-[#0086D3]/20 shadow-[0_0_12px_rgba(0,134,211,0.1)]' : 'border border-transparent hover:bg-white/[0.04]'}`} onClick={() => {
              setActiveSubItem(category.id);
              setActiveSubItemTitle(category.label)
            }}>
              <span className={`transition-all duration-300 ${activeSubItem === category.id ? '[&_svg]:opacity-100 [&_svg]:brightness-125' : '[&_svg]:opacity-40'} [&_svg]:w-[20px] [&_svg]:h-[20px]`}>{category.icon}</span>
              <h2 className={`text-[14px] md:text-[16px] font-semibold whitespace-nowrap transition-colors duration-300 ${activeSubItem === category.id ? 'text-white' : 'text-white/40'}`}>{category.label}</h2>
            </button>
          ))}
        </div>
      </section>
      {activeSubItem === "All" ? (!search ? categoriesGames.map((category) => {
        return <GameWithCategories title={category.label} categoryType={category.id} key={category.id} />
      }) : <GameWithCategories title={t('mainScreen.search')} searchText={search} categoryType={activeSubItem} key={activeSubItem} />) : <AllGamesByCategory title={activeSubItemTitle} categoryType={activeSubItem} key={activeSubItem} />}
    </div>
  );
};

export default Casino;